import React from "react";
import { ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { RootState } from "../../store/store";
import { useSelector } from "react-redux";

interface NavMenuComponentProps {
    selectedTab: number;
    setSelectedTab: React.Dispatch<React.SetStateAction<number>>;
    icon: React.ReactNode;
    text: string;
    tabNumber: number;
};

const NavMenuComponent: React.FC<NavMenuComponentProps> = ({ selectedTab, setSelectedTab, icon, text, tabNumber }) => {
    const { navMenuDisabled } = useSelector((state: RootState) => state.componentDisable);

    return (
        <ListItemButton disabled={navMenuDisabled} style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            borderRight: selectedTab === tabNumber ? '5px solid #2c3e50' : 'none',
        }} onClick={() => setSelectedTab(tabNumber)}>
            <ListItemIcon style={{
                display: 'flex',
                justifyContent: 'center',
            }}>
                {icon}
            </ListItemIcon>
            <ListItemText style={{
                textAlign: 'center'
            }} secondary={text} />
        </ListItemButton>
    );
};

export default NavMenuComponent;